export default __webpack_public_path__ + "static/media/modal_cross_icon_gray.cce1f07d.svg";